import React from 'react';
import { InputBase, CustomDateInput } from '../../../Helper/InputBase';
import { formatter } from '../../../../utility';
import { NormalizationConstants } from '../../../../constants';
import moment from 'moment';

const DROPDOWN_NO_VALUE = '0';
const DROPDOWN_YES_VALUE = '1';

const FutureRentIncreaseQuestions = (props) => {
  const { decisionDate, isExistingRentIncrease, existingNoticeServiceDate, existingRentEffectiveDate, previousYearRentIncreaseDate, existingRentAmount, errors, handleChange, handleDateChange, handleIsExistingRentIncrease, handleExistingNoticeServiceDateChange, disabled } = props;

  const renderYesQuestions = () => {
    if (isExistingRentIncrease !== DROPDOWN_YES_VALUE) return;
    return (
      <>
        <div className="fri-questions__input-wrapper">
          <CustomDateInput
            name='existingNoticeServiceDate'
            disabled={disabled}
            value={existingNoticeServiceDate}
            errors={errors.existingNoticeServiceDate}
            cssClass='fri-questions__existing-notice'
            minDate={moment(decisionDate).subtract(6, 'months').toDate() || null}
            label='When did you serve the notice for this future rent increase to the tenant?'
            handleChange={handleExistingNoticeServiceDateChange}
          />
        </div>
        <div className="fri-questions__input-wrapper">
          <CustomDateInput
            name='existingRentEffectiveDate'
            disabled={disabled}
            value={existingRentEffectiveDate}
            errors={errors.existingRentEffectiveDate}
            cssClass='fri-questions__existing-rent-date'
            minDate={(moment(existingNoticeServiceDate).isBefore(moment(decisionDate)) || moment(existingNoticeServiceDate).isAfter(moment(previousYearRentIncreaseDate)) ? moment(decisionDate).add(1, 'day').toDate() : existingNoticeServiceDate) || null}
            label='What is the effective date of the future rent increase?'
            handleChange={handleDateChange}
          />
        </div>
        <div className="fri-questions__input-wrapper">
          <InputBase
            name='existingRentAmount'
            startAdornment='$'
            disabled={disabled}
            errors={errors.existingRentAmount}
            value={existingRentAmount}
            cssClass='fri-questions__existing-rent-amount'
            type='number'
            label='What is the rent amount after the future rent increase takes effect?'
            maxLength={NormalizationConstants.maxDollarLength}
            handleChange={handleChange}
          />
        </div>
      </>
    )
  }
  return (
    <div className="fri-questions">
      <div className="fri-questions__input-wrapper">
        <InputBase
            name='isExistingRentIncrease'
            disabled={disabled}
            cssClass='fri-questions__existing-rent-increase'
            errors={errors.isExistingRentIncrease}
            type='select'
            value={isExistingRentIncrease}
            label={`Did you already serve notice for a future rent increase that will be effective after the decision date ${decisionDate ? `(${formatter.toDateDisplay(decisionDate)})` : ''}  for this unit that does <b>not</b> include your eligible amount from your Phase 1 rent increase?`}
            handleSelectChange={handleIsExistingRentIncrease}
            selectList={[ { text: 'No', value: DROPDOWN_NO_VALUE }, { text: 'Yes', value: DROPDOWN_YES_VALUE } ]}
          />
      </div>
      {renderYesQuestions()}
    </div>
  );
};

export default FutureRentIncreaseQuestions;